import { ColorResult, SketchPicker } from 'react-color'
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import { PreviewColor } from '../../FormStyle';
import { useTranslation } from 'react-i18next';
import { modeloStyleType } from '../../../../service/checklistStyle';
import { trackEventMatomo } from '../../../../helpers/matomo';
import { Paragraph } from '../../../Notifications/style/SingleNotificationStyle';
import { Stack, TextField } from '@mui/material';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';

type props = {
  objectToEdit: modeloStyleType
  setObjectToEdit: Function,
  fonts: string[],
  selected: string,
}

export default function EstilosComp({
  objectToEdit,
  setObjectToEdit,
  selected,
  fonts }: props) {

  const { t } = useTranslation('translation');

  function getBase64(file: File, cb: (s: string) => void) {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      cb(reader.result as string)
    }
    reader.onerror = function (error) {
      console.log('Error: ', error);
    };
  }

  const renderImages = (File: FileList | null) => {
    if (File) {
      Array.from(File).map(e => getBase64(e, (i) => setObjectToEdit({ ...objectToEdit, logo: i })));
    }
  }

  return (
    <Stack
      sx={{ padding: '10px', width: '100%' }}
      direction="row"
      justifyContent="flex-start"
      alignItems="flex-start"
      spacing={2}
    >
      <Stack
        direction="column"
        justifyContent="flex-start"
        alignItems="flex-start"
        spacing={0.5}
      >
        <Stack
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
        >
          <Paragraph style={{ fontSize: '12px' }}>{t('checklists.chooseBackgroundColor')}</Paragraph>
          <PreviewColor
            style={{
              backgroundColor: `${selected === 'header'
                ? (objectToEdit?.colorHeader as string)
                : (objectToEdit?.background as string)}`,
              border: 'gray 1px solid'
            }} />
        </Stack>
        <SketchPicker
          width='110px'
          color={`${selected === 'header'
            ? (objectToEdit?.colorHeader as string)
            : (objectToEdit?.background as string)}`}
          onChangeComplete={
            (color: ColorResult) => {
              trackEventMatomo('Configurar impressões form deslogado', 'click', 'input', 'seleciona cor')
              selected === 'header'
                ? setObjectToEdit({ ...objectToEdit, colorHeader: color.hex })
                : setObjectToEdit({ ...objectToEdit, background: color.hex })
            }
          }
          disableAlpha
          presetColors={[]}
        />
      </Stack>
      <Stack
        direction="column"
        justifyContent="flex-start"
        alignItems="flex-start"
        spacing={0.5}
      >
        <Stack
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
        >
          <Paragraph style={{ fontSize: '12px' }}>{t('checklists.chooseFontColor')}</Paragraph>
          <PreviewColor style={{
            backgroundColor: `${selected === 'header'
              ? (objectToEdit?.fontHeader?.color as string)
              : (objectToEdit.fontBackground?.color)}`,
            border: 'gray 1px solid'
          }} />
        </Stack>
        <SketchPicker
          width='110px'
          color={`${selected === 'header'
            ? (objectToEdit?.fontHeader?.color as string)
            : (objectToEdit.fontBackground?.color)}`}
          onChangeComplete={
            (color: ColorResult) => {
              trackEventMatomo('Configurar impressões form deslogado', 'click', 'input', 'seleciona cor')
              selected === 'header'
                ? setObjectToEdit({
                  ...objectToEdit,
                  fontHeader: { ...objectToEdit?.fontHeader, color: color?.hex }
                })
                : setObjectToEdit({
                  ...objectToEdit,
                  fontBackground: { ...objectToEdit?.fontBackground, color: color?.hex }
                })
            }
          }
          disableAlpha
          presetColors={[]}
        />
      </Stack>
      <Stack
        direction="column"
        justifyContent="flex-start"
        alignItems="center"
        spacing={0.5}
      >
        <Stack
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={0}
          sx={{ width: '100%' }}
        >
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Escolha fonte</InputLabel>
            <Select
              size='small'
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              defaultValue={selected === 'header'
                ? objectToEdit?.fontHeader?.fontFamily
                : objectToEdit?.fontBackground?.fontFamily}
              onClick={() => trackEventMatomo('Configurar impressões form deslogado', 'click', 'select', 'seleciona fonte')}
              value={selected === 'header'
                ? objectToEdit?.fontHeader?.fontFamily
                : objectToEdit?.fontBackground?.fontFamily}
              label="Escolha fonte"
              onChange={(e) => {
                selected === 'header'
                  ? setObjectToEdit({
                    ...objectToEdit,
                    fontHeader:
                    {
                      ...objectToEdit?.fontHeader,
                      fontFamily: e.target.value
                    }
                  })
                  : setObjectToEdit({
                    ...objectToEdit,
                    fontBackground:
                    {
                      ...objectToEdit?.fontBackground,
                      fontFamily: e.target.value
                    }
                  })
              }}
            >
              {fonts?.map((name) => (
                <MenuItem
                  key={name}
                  value={name}
                >
                  {name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            size='small'
            onClick={() => trackEventMatomo('Configurar impressões form deslogado', 'click', 'input', 'tamanho da fonte')}
            value={selected === 'header'
              ? objectToEdit?.fontHeader?.fontSize
              : objectToEdit?.fontBackground?.fontSize}
            onChange={(e) => {
              selected === 'header'
                ? setObjectToEdit({
                  ...objectToEdit,
                  fontHeader: {
                    ...objectToEdit?.fontHeader,
                    fontSize: Number(e.target.value)
                  }
                }) : setObjectToEdit({
                  ...objectToEdit,
                  fontBackground: {
                    ...objectToEdit?.fontBackground,
                    fontSize: Number(e.target.value)
                  }
                })
            }}
            sx={{ width: '100px' }}
          />
          <TextField sx={{ width: '50px' }} variant='standard' size='small' disabled value={'px'} />
        </Stack>
        {selected === 'header' && <>
          <Paragraph style={{ fontSize: '12px' }}>{t('checklists.printConfig.headerPicture')}</Paragraph>
          <label className='button is-success is-small'>
            <input
              style={{ display: 'none' }}
              accept="image/png, image/jpeg"
              className="file-input"
              value={''}
              id="img"
              name="img"
              type="file"
              onChange={(e) => {
                trackEventMatomo('Configurar impressões form deslogado', 'click', 'input', 'adiciona imagem')
                renderImages(e.target.files)
              }}
            />
            {t('users.userRegister.selectMessage')}&nbsp;
            <AddPhotoAlternateIcon />
          </label>
          {objectToEdit?.logo &&
            <Stack
              direction="row"
              justifyContent="center"
              alignItems="flex-start"
              spacing={0.5}
            >
              <img width={'80px'} src={objectToEdit.logo} />
              <RemoveCircleIcon color='error'
                onClick={() => {
                  setObjectToEdit({ ...objectToEdit, logo: null })
                }} />
            </Stack>}
        </>}
      </Stack>
    </Stack>
  )
}
